// @ts-nocheck
import { popoverStyles } from "@store/Themes/common/mixins/popover";
import { sideMenuLinkStyles, sideMenuWrapperStyles } from "@store/Themes/common/mixins/sidemenu";
import getColor from "@insite/mobius/utilities/getColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

// Store Custom Code - >
const overflowMenu: Styleguide["overflowMenu"] = {
    defaultProps: {
        buttonProps: {
            css: css`
                background: transparent;
                border-radius: 0;
                min-width: 0;
                &:hover,
                &:active,
                &:focus {
                    background: transparent;
                    border-color: transparent;
                }
            `,
        },
        cssOverrides: {
            menu: css`
                ${sideMenuWrapperStyles()}
                ${popoverStyles()}
            `,
            menuItem: css`
                &:hover,
                &:active,
                &:focus {
                    background: transparent;
                    color: inherit;
                }
                ${sideMenuLinkStyles()}
            `,
        },
    },
};
// <-- Majestic Custom Code
export default overflowMenu;
